import { render, staticRenderFns } from "./ConfirmDisconnectModal.vue?vue&type=template&id=04df2c20&"
import script from "./ConfirmDisconnectModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmDisconnectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports